import { ApolloCache } from "@apollo/client";

/**
 * Evict form_template from ROOT_QUERY cache in Apollo
 */
export const evictFormTemplateCache = (cache: ApolloCache<unknown>) => {
  cache.evict({ fieldName: "form_template" });
  cache.gc();
};

export const evictFormCache = (cache: ApolloCache<unknown>) => {
  cache.evict({ fieldName: "form" });
  cache.gc();
};

export const evictEnrollmentSchoolsGradesCache = (
  cache: ApolloCache<unknown>
) => {
  cache.evict({ fieldName: "school" });
  cache.evict({ fieldName: "school_by_pk" });
  cache.evict({ fieldName: "grades_group" });
  cache.evict({ fieldName: "grade" });
  cache.evict({ fieldName: "program_group" });
  cache.evict({ fieldName: "grade_config" });
  cache.gc();
};

export const evictMatchPublishEventCache = (cache: ApolloCache<unknown>) => {
  cache.evict({ fieldName: "match_run_publish_event" });
  cache.gc();
};
